/**
 * Shared constants for services
 */
export const SERVICE_CONSTANTS = {
  // Service Worker Update Configuration
  SW_UPDATE: {
    CHECK_INTERVAL_MS: 1 * 60 * 1000, // 1 minute
    MAX_FAILURES: 3,
    COOLDOWN_MS: 10 * 60 * 1000 // 10 minutes
  },

  // Update Notification Configuration
  UPDATE_NOTIFICATION: {
    DUPLICATE_PREVENTION_MS: 5000,
    NOTIFICATION_RESET_MS: 30000
  },

  // Event Types
  EVENTS: {
    NEW_VERSION_AVAILABLE: 'NEW_VERSION_AVAILABLE',
    SW_UPDATED: 'SW_UPDATED',
    PUSH_NOTIFICATION_RECEIVED: 'PUSH_NOTIFICATION_RECEIVED',
    // Custom window events
    SW_PUSH_NOTIFICATION: 'sw-push-notification',
    SW_UPDATED_CUSTOM: 'sw-updated',
  },

  // PWA Display Modes
  PWA_DISPLAY_MODES: {
    TWA: 'twa',
    BROWSER: 'browser',
    STANDALONE: 'standalone',
    MINIMAL_UI: 'minimal-ui',
    FULLSCREEN: 'fullscreen',
    WINDOW_CONTROLS_OVERLAY: 'window-controls-overlay',
    UNKNOWN: 'unknown'
  }
} as const;
